import React from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import { List } from '@sunrun/component-library';

const ComponentList = ({ items, renderListItem: ListItem }) => (
  <List>
    {items.map(item => (
      <ListItem key={v4()} item={item} />
    ))}
  </List>
);

ComponentList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
  renderListItem: PropTypes.elementType.isRequired,
};

export default ComponentList;
